module.exports = __webpack_public_path__ + "media/components/country-flag/static/mm-6d702a74ce6149ddb4a4fe643f12d1fa.svg";